module.exports = __webpack_public_path__ + "static/media/icon-supplies-toothpaste.2ee29d43.svg";